import { Location } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable, startWith } from 'rxjs';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { DriverService } from 'src/app/shared/services/driver.service';
import { FactoryService } from 'src/app/shared/services/factory.service';
import { LoadingOrderService } from 'src/app/shared/services/loading-order.service';
import { ProductsService } from 'src/app/shared/services/products.service';
import { TransporterService } from 'src/app/shared/services/transporter.service';
import { UserService } from 'src/app/shared/services/user.service';
import { VehicleService } from 'src/app/shared/services/vehicle.service';
import { IVehicleTypes } from 'src/assets/static-data/enums/vehicle-types.enum';
import { ILoadingOrder } from 'src/core/interfaces/loading-order';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-loading-order',
  templateUrl: './add-loading-order.component.html',
  styleUrl: './add-loading-order.component.scss'
})
export class AddLoadingOrderComponent {
  LoadingOrders: ILoadingOrder[];
  // loadingOrderForm: UntypedFormGroup;
  vehicles: any[];
  products: any[];
  customers: any[];
  factories: any[];
  transporters: any[];
  filteredCustomers: any;
  filteredProducts: any;
  filteredfactories: any;
  @ViewChild('customerSelect') customerSelect: MatSelect;
  @ViewChild('productSelect') productSelect: MatSelect;
  @ViewChild('factorySelect') factorySelect: MatSelect;
  @ViewChild('transporterSelect') transporterSelect: MatSelect; // Add a ViewChild for the transporter select
  @ViewChild('vehicleSelect') vehicleSelect: MatSelect; 
  @ViewChild('driverSelect') driverSelect: MatSelect; // Add a ViewChild for the transporter select

  locations: string[];
  drivers: any;
  customer: any;
  customerLocations: any;
  isLoading: boolean;
  loadingOrderDataFromSalesOrder: any;
  data: any;
  loadingOrderForm: FormGroup;
  loadingOrderId: number;
  AvailableQuantity: any;
  totalRequestedQuantity: any;
  loadedQuantity: any;
  searchTextTransporter: string = '';
  filteredTransporters: any[] = [];
  searchText: string;
  driverSearchControl = this.fb.control('');
  filteredDrivers: any[] = [];
  filteredVehicles: any[];
  searchTextDriver: string = '';
  searchTransporterText: string;
  @ViewChild('inputVehicleRef', { static: true })
  inputVehicleElement!: ElementRef;
  @ViewChild('inputDriverRef', { static: true })
  inputDriverElement!: ElementRef;
  @ViewChild('inputTransporterRef', { static: true })
  inputTransporterElement!: ElementRef;
  vehicleType = Object.keys(IVehicleTypes).filter((key) => isNaN(Number(key))); // Only keys
  IVehicleTypes = IVehicleTypes; // Expose the enum to the template
  transporterDrivers: any[] = [];

  constructor(
    private loadingOrderService: LoadingOrderService,
    private router: Router,
    private translateService: TranslateService,
    private fb: UntypedFormBuilder,
    private vehicleService: VehicleService,
    private productService: ProductsService,
    private transporterService: TransporterService,
    private customerService: CustomerService,
    private UserService: UserService,
    private factoryService: FactoryService,
    private driverService: DriverService,
    private location: Location,
    private route: ActivatedRoute
  ) {}
  ngOnInit() {
    this.loadingOrderId = Number(this.route.snapshot.paramMap.get('id'));

    this.initForm();
    this.loadLoadingOrderDataFromSalesOrder(this.loadingOrderId);
    // this.loadingOrderForm.get('customerId')?.disable();
    // this.loadingOrderForm.get('searchProduct')?.disable();
    // this.loadingOrderForm.get('searchCustomer')?.disable();

    this.loadingOrderForm.get('customerId')?.valueChanges.subscribe((value) => {
      this.customerService.getCustomerById(value).subscribe((response) => {
        this.customer = response.data;

        const factoryDeliveryAddress = {
          id: -1, // ID to be sent to backend
          name: this.translateService.instant('ISFACTORYDELIVERY.TEXT') // Default name
          // Add any other necessary fields here
        };


        this.customerLocations = [
            factoryDeliveryAddress,
            ...this.customer.customerAddresses];
     
      });
    });
    //Customer Data
    this.customerService.getAllCustomers().subscribe((response) => {
      this.customers = response.data;
      this.filteredCustomers = response.data;
    });

    this.loadingOrderForm.get('driverId')?.valueChanges.subscribe((value) => {
      if (value) {
        const selectedDriver = this.transporterDrivers.find(driver => driver.id == value);
        if (selectedDriver && selectedDriver.assignedVehicleId  && !this.loadingOrderForm.get('vehicleId')?.value) {
          this.loadingOrderForm.get('vehicleId').setValue(selectedDriver.assignedVehicleId);
        } else {
          const vehicleId = this.loadingOrderForm.get('vehicleId')?.value;
          this.loadingOrderForm.get('vehicleId').setValue(vehicleId);
        }
      }
    });



    


    this.loadingOrderForm.get('vehicleId')?.valueChanges.subscribe((value) => {
      const selectedVehicle = this.filteredVehicles.find(vehicle => vehicle.id == value);
      
      if (this.loadingOrderForm.get('driverId')?.value == '') {
        if (selectedVehicle && selectedVehicle.drivers.length > 0) {
          this.loadingOrderForm.get('driverId').setValue(selectedVehicle.drivers[0].id);
        } else {
          this.loadingOrderForm.get('driverId').setValue(null);
        }
      }
    });
  

 

    // this.loadingOrderForm
    //   .get('transporterId')
    //   ?.valueChanges.subscribe((value) => {
    //     this.vehicleService
    //       .getTransporterVehicles(value)
    //       .subscribe((response) => {
    //         this.vehicles = response.data;
    //       });
    //   });

    this.loadingOrderForm.get('transporterId')?.valueChanges.subscribe((value) => {
      this.vehicleService.getTransporterVehicles(value).subscribe((response) => {
        this.vehicles = response.data;
        this.filteredVehicles = response.data; // Store the original list
        console.log("Vehicles : ",this.vehicles);
        console.log(this.filteredVehicles)
      });
    });

    //Product Data
    this.productService.getProducts().subscribe((response) => {
      this.products = response.data;
      this.filteredProducts = response.data;
    });

    this.loadingOrderForm
      .get('searchProduct')
      ?.valueChanges.subscribe((searchText: string) => {
        this.filteredProducts = this.products.filter((product) =>
          product.name.toLowerCase().includes(searchText.toLowerCase())
        );
        if (searchText && this.productSelect) {
          this.productSelect.open();
        }
      });

    this.loadingOrderForm.get('itemId')?.valueChanges.subscribe((value) => {
      if (value) {
        this.loadingOrderForm.get('searchProduct')?.setValue('');
      }
    });

    this.customerService.getAllCustomers().subscribe((response) => {
      this.customers = response.data;
    });

    this.loadingOrderForm.get('customerId')?.valueChanges.subscribe((value) => {
      this.customerService.getCustomerById(value).subscribe((response) => {
        this.customer = response.data;
        const factoryDeliveryAddress = {
          id: -1, // ID to be sent to backend
          name: this.translateService.instant('ISFACTORYDELIVERY.TEXT') // Default name
          // Add any other necessary fields here
        };


        this.customerLocations = [
            factoryDeliveryAddress,
            ...this.customer.customerAddresses          ];
      });
    });

    this.factoryService.getFactories().subscribe((response) => {
      this.factories = response.data;
      this.filteredfactories = response.data;
    });


    this.loadingOrderForm.get('transporterId')?.valueChanges.subscribe((value) => {
      this.transporterService.getTransporterDrivers(value).subscribe((response) => {
        this.transporterDrivers = response.data;
        this.filteredDrivers = response.data;
      });
    });



    this.loadingOrderForm.get('customerId')?.valueChanges.subscribe((value) => {
      this.customerService.getCustomerById(value).subscribe((response) => {
        this.customer = response.data;
        const factoryDeliveryAddress = {
          id: -1, // ID to be sent to backend
          name: this.translateService.instant('ISFACTORYDELIVERY.TEXT') // Default name
          // Add any other necessary fields here
        };


        this.customerLocations = [
            factoryDeliveryAddress,
            ...this.customer.customerAddresses          ];
      });
    });

    this.transporterService.getTransporters(true).subscribe((response) => {
      this.transporters = response.data;
      this.filteredTransporters = response.data; // Initialize filteredTransporters
    });
  }

  shouldDisable(driver:any){
    if(driver.isBusy) return true;
    return false
  }

  initForm() {
    this.loadingOrderForm = this.fb.group({
      //vehicleTypeName: [''],
      vehicleType:[''],
      factoryId: [''],
      customerId: [''],
      customerAddressId: [''],
      customerCountry: [''],
      searchCustomer: [''],
      searchProduct: [''],
      searchFactory: [''],
      itemId: [''],
      status: [''],
      transactionDate: [''],
      customerRefNo: [''],
      numberOfRequests: [''],
      transporterId: [''],
      vehicleId: [''],
      driverId: [''],
      quantity: [
        '',
        [
          Validators.required,
          Validators.min(1),
          this.maxQuantityValidator.bind(this)
        ]
      ],
      parentSalesOrderLineId: ['']
    });

    //this.loadingOrderForm.get('customerId')?.disable();
    //this.loadingOrderForm.get('itemId')?.disable();
    this.loadingOrderForm.get('searchProduct')?.disable();
    this.loadingOrderForm.get('searchCustomer')?.disable();
  }
  maxQuantityValidator(control) {
    if (
      this.AvailableQuantity !== undefined &&
      control.value > this.AvailableQuantity
    ) {
      return { maxQuantityExceeded: true };
    }
    return null;
  }

  loadLoadingOrderDataFromSalesOrder(id: number) {
    this.loadingOrderService
      .getLoadingOrderDataFromSalesOrderLine(id)
      .subscribe((response) => {
        // // debugger;
        console.log(response.data);
        this.data = response.data;
        this.totalRequestedQuantity = parseInt(this.data.totalRequestedQuantity);
        console.log("totalRequestedQuantity", this.totalRequestedQuantity);
        this.loadedQuantity = parseInt(this.data.loadedQuantity);
        console.log("loadedQuantity", this.loadedQuantity);
        this.AvailableQuantity = response.data.quantityAvaliableForLoading;
        if (this.AvailableQuantity == 0) {
          this.loadingOrderForm
            .get('quantity')
            ?.setErrors({ maxQuantityExceeded: true });
        }
        this.loadingOrderForm.patchValue({
          parentSalesOrderLineId: this.data.parentSalesOrderLineId,
          factoryId: this.data.factoryId,
          customerId: this.data.customerId,
          itemId: this.data.itemId,
          transporterId: this.data.transporterId,
          customerCountry: this.data.customerCountry,
          customerRefNo: this.data.parentSalesOrderNumber,
          numberOfRequests: this.data.numberOfRequests,
          vehicleId: this.data.vehicleId,
          quantity: this.data.quantity,
          driverId: this.data.driverId,
          customerAddressId: this.data.customerAddressId,
          status: this.data.status,
          transactionDate: this.data.transactionDate
        });
      });
  }

  onBack() {
    this.location.back();
  }

  send() {
    if (this.loadingOrderForm.invalid) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: this.translateService.instant('CHECK_ENTERED_DATA.TEXT'),
        timer: 2000
      });
      return;
    }
    let loadingOrder = this.loadingOrderForm.getRawValue();
    loadingOrder.status = 1;
    this.loadingOrderService.add(loadingOrder).subscribe(() => {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: this.translateService.instant(
          'LOADING_ORDER_CREATED_SUCCESSFULLY.TEXT'
        ),
        timer: 1500
      });
      this.router.navigate(['/transactions/loading-order']);
    });
  }

  saveAsDraft() {
    if (this.loadingOrderForm.invalid) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: this.translateService.instant('CHECK_ENTERED_DATA.TEXT'),
        timer: 2000
      });
      return;
    }
    // // debugger;
    console.log(this.loadingOrderForm.get('transactionDate').value.toISOString);
    let loadingOrder = this.loadingOrderForm.getRawValue();
    loadingOrder.status = 0;
    this.loadingOrderService.add(loadingOrder).subscribe(() => {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: this.translateService.instant(
          'LOADING_ORDER_CREATED_SUCCESSFULLY.TEXT'
        ),
        timer: 1500
      });
      this.router.navigate(['/transactions/loading-order']);
    });
  }

  //0:vehicleType,1:truck
  selectOption(event: MatSelectChange,type:number){
    // debugger
    if(event.value &&type==1){
      this.loadingOrderForm.get('driverId').setValue(this.drivers.filter(driver=>driver.assignedVehicleId==event.value)[0]?.id);
    }
  }

  filterDrivers(event: Event) {
    const input = (event.target as HTMLInputElement).value;
    if (!this.transporterDrivers) {
      console.error('transporterDrivers is not initialized');
      return;
    }

    if (input) {
      console.log(input);
      this.driverSelect.open();
      // Combine firstName and lastName filters
      this.filteredDrivers = this.transporterDrivers.filter(
        (driver) =>
          driver.firstName.toLowerCase().includes(input.toLowerCase()) ||
          driver.lastName.toLowerCase().includes(input.toLowerCase())  ||
          driver.contactNumber.toLowerCase().includes(input.toLowerCase())  ||
          driver.residenceNumber.toLowerCase().includes(input.toLowerCase())
      );
    } else {
      this.filteredDrivers = this.transporterDrivers; // Reset to full list
    }

    this.loadingOrderForm.get('driverId')?.valueChanges.subscribe((value) => {
      if (value) {
        const selectedDriver = this.transporterDrivers.find(driver => driver.id == value);
        if (selectedDriver && selectedDriver.assignedVehicleId) {
          this.loadingOrderForm.get('vehicleId').setValue(selectedDriver.assignedVehicleId);
        } else {
          this.loadingOrderForm.get('vehicleId').setValue(null);
        }
      }
    });
  }

  filterVehicles(event: Event) {
    const input = (event.target as HTMLInputElement).value;

    if (input) {
      this.vehicleSelect.open();
      // Filter vehicles based on the search input
      this.vehicles = this.vehicles.filter((vehicle) =>
        vehicle.name.toLowerCase().includes(input.toLowerCase())
      );
    } else {
      // Reset to the full list of vehicles if the search input is empty
      this.vehicles = this.filteredVehicles;
    }

    this.loadingOrderForm.get('vehicleId')?.valueChanges.subscribe((value) => {
      const selectedVehicle = this.vehicles.find(vehicle => vehicle.id == value);
      
      // Check if driverId is not already selected
      if (this.loadingOrderForm.get('driverId')?.value == '') {
        if (selectedVehicle && selectedVehicle.drivers.length > 0) {
          // Set driverId to the first driver's ID if no driver is currently selected
          this.loadingOrderForm.get('driverId').setValue(selectedVehicle.drivers[0].id);
        } else {
          // Set driverId to null if there are no drivers available
          this.loadingOrderForm.get('driverId').setValue(null);
        }
      }
    });
  }

  filterTransporters(event: Event) {
    const input = (event.target as HTMLInputElement).value;

    if (input) {
      this.transporterSelect.open();
      // Combine firstName and lastName filters
      this.filteredTransporters = this.transporters.filter((transporter) =>
        transporter.name.toLowerCase().includes(input.toLowerCase())
      );
    } else {
      this.filteredTransporters = this.transporters; // Reset to full list
    }
  }
  

  clearSearchText() {
    // // debugger;
    this.inputTransporterElement.nativeElement.value = ''; // Clear the input field
    this.inputDriverElement.nativeElement.value = ''; // Clear the input field
    this.inputVehicleElement.nativeElement.value = ''; // Clear the input field
    this.filteredDrivers = this.transporterDrivers; // Reset the filtered drivers
    this.filteredTransporters = this.transporters; // Reset the filtered drivers
    this.filteredVehicles = this.vehicles; 
  }

  removeDriverFilter(event: Event){
    event.stopPropagation(); // Prevent the dropdown from toggling
    this.loadingOrderForm.get('driverId').patchValue('');
  }

  removeVehicleFilter(event: Event){
    event.stopPropagation(); // Prevent the dropdown from toggling
    this.loadingOrderForm.get('vehicleId').patchValue('');
  }

  removeTransporterFilter(event: Event){
    event.stopPropagation(); // Prevent the dropdown from toggling
    this.loadingOrderForm.get('transporterId').patchValue('');
    this.loadingOrderForm.get('driverId').patchValue('');
    this.loadingOrderForm.get('vehicleId').patchValue('');
  }
}
